export interface CityByDepartment {
  [department: string]: string[];
}

export const COLOMBIAN_CITIES: CityByDepartment = {
  "Amazonas": [
    "Leticia",
    "Puerto Nariño"
  ],
  "Antioquia": [
    "Medellín",
    "Bello",
    "Itagüí",
    "Envigado",
    "Apartadó",
    "Turbo",
    "Rionegro",
    "Sabaneta",
    "Caldas",
    "La Estrella",
    "Copacabana",
    "Girardota",
    "Barbosa",
    "Caucasia",
    "Necoclí",
    "Chigorodó",
    "La Ceja",
    "Carmen de Viboral",
    "Puerto Berrío",
    "Segovia"
  ],
  "Arauca": [
    "Arauca",
    "Tame",
    "Saravena",
    "Fortul",
    "Puerto Rondón",
    "Cravo Norte",
    "Arauquita"
  ],
  "Atlántico": [
    "Barranquilla",
    "Soledad",
    "Malambo",
    "Sabanagrande",
    "Puerto Colombia",
    "Galapa",
    "Sabanalarga",
    "Baranoa",
    "Usiacurí",
    "Juan de Acosta",
    "Piojó",
    "Polonuevo",
    "Ponedera",
    "Palmar de Varela",
    "Santo Tomás",
    "Candelaria",
    "Manatí",
    "Repelón",
    "Luruaco",
    "Tubará",
    "Campo de la Cruz",
    "Santa Lucía",
    "Suan"
  ],
  "Bolívar": [
    "Cartagena",
    "Magangué",
    "Turbaco",
    "Arjona",
    "El Carmen de Bolívar",
    "Mompós",
    "San Pablo",
    "Santa Rosa del Sur",
    "Simití",
    "Morales",
    "San Jacinto",
    "María la Baja",
    "Mahates",
    "Clemencia",
    "Santa Catalina",
    "Villanueva",
    "Soplaviento",
    "Calamar",
    "San Estanislao",
    "Río Viejo"
  ],
  "Boyacá": [
    "Tunja",
    "Duitama",
    "Sogamoso",
    "Chiquinquirá",
    "Paipa",
    "Villa de Leyva",
    "Barbosa",
    "Moniquirá",
    "Puerto Boyacá",
    "Garagoa",
    "Nobsa",
    "Tibasosa",
    "Samacá",
    "Ventaquemada",
    "Oicatá",
    "Combita",
    "Motavita",
    "Siachoque",
    "Toca",
    "Soracá"
  ],
  "Caldas": [
    "Manizales",
    "Chinchiná",
    "Villamaría",
    "La Dorada",
    "Riosucio",
    "Anserma",
    "Palestina",
    "Neira",
    "Supía",
    "Filadelfia",
    "Marmato",
    "Aguadas",
    "Pácora",
    "Salamina",
    "Aranzazu",
    "Belalcázar",
    "San José",
    "Risaralda",
    "Viterbo",
    "Marquetalia",
    "Pensilvania",
    "Manzanares",
    "Marulanda",
    "Victoria",
    "Samaná",
    "Norcasia"
  ],
  "Caquetá": [
    "Florencia",
    "San Vicente del Caguán",
    "Puerto Rico",
    "La Montañita",
    "Paujil",
    "Doncello",
    "Belén de los Andaquíes",
    "Albania",
    "Curillo",
    "Milán",
    "Morelia",
    "Valparaíso",
    "Cartagena del Chairá",
    "San José del Fragua",
    "Solano",
    "Solita"
  ],
  "Casanare": [
    "Yopal",
    "Aguazul",
    "Villanueva",
    "Tauramena",
    "Monterrey",
    "Sabanalarga",
    "Maní",
    "Trinidad",
    "Recetor",
    "Chameza",
    "Hato Corozal",
    "La Salina",
    "Nunchía",
    "Orocué",
    "Paz de Ariporo",
    "Pore",
    "San Luis de Palenque",
    "Támara"
  ],
  "Cauca": [
    "Popayán",
    "Santander de Quilichao",
    "Puerto Tejada",
    "Patía",
    "Corinto",
    "Guachené",
    "Villa Rica",
    "Caloto",
    "Padilla",
    "Miranda",
    "Cajibío",
    "Silvia",
    "Piendamó",
    "Morales",
    "Suárez",
    "Timbío",
    "Rosas",
    "La Sierra",
    "Sotará",
    "Puracé"
  ],
  "Cesar": [
    "Valledupar",
    "Aguachica",
    "Bosconia",
    "Codazzi",
    "La Paz",
    "San Diego",
    "Curumaní",
    "El Copey",
    "Astrea",
    "Becerril",
    "Chimichagua",
    "Chiriguaná",
    "El Paso",
    "Gamarra",
    "González",
    "La Gloria",
    "La Jagua de Ibirico",
    "Manaure",
    "Pailitas",
    "Pelaya",
    "Pueblo Bello",
    "Río de Oro",
    "San Alberto",
    "San Martín",
    "Tamalameque"
  ],
  "Chocó": [
    "Quibdó",
    "Istmina",
    "Condoto",
    "Riosucio",
    "Acandí",
    "Unguía",
    "Turbo",
    "Apartadó",
    "Carepa",
    "Chigorodó",
    "Mutatá",
    "Vigía del Fuerte",
    "Bojayá",
    "Medio Atrato",
    "Atrato",
    "Río Quito",
    "Lloró",
    "Bagadó",
    "Carmen del Darién",
    "Cértegui",
    "Tadó",
    "Unión Panamericana",
    "San José del Palmar",
    "Sipí",
    "Novita",
    "Medio San Juan",
    "Litoral del San Juan",
    "Bahía Solano",
    "Juradó",
    "Nuquí",
    "Alto Baudó",
    "Bajo Baudó"
  ],
  "Córdoba": [
    "Montería",
    "Lorica",
    "Cereté",
    "Sahagún",
    "Planeta Rica",
    "Montelíbano",
    "Tierralta",
    "Ayapel",
    "Chinú",
    "Ciénaga de Oro",
    "Cotorra",
    "La Apartada",
    "Los Córdobas",
    "Momil",
    "Moñitos",
    "Pueblo Nuevo",
    "Puerto Escondido",
    "Puerto Libertador",
    "Purísima",
    "San Andrés Sotavento",
    "San Antero",
    "San Bernardo del Viento",
    "San Carlos",
    "San José de Uré",
    "San Pelayo",
    "Tuchín",
    "Valencia",
    "Canalete",
    "Buenavista",
    "San Pedro de Urabá"
  ],
  "Cundinamarca": [
    "Bogotá",
    "Soacha",
    "Girardot",
    "Zipaquirá",
    "Facatativá",
    "Chía",
    "Mosquera",
    "Madrid",
    "Funza",
    "Cajicá",
    "Sibaté",
    "Tocancipá",
    "La Calera",
    "Sopó",
    "Tabio",
    "Tenjo",
    "Cota",
    "Gachancipá",
    "Sesquilé",
    "Guatavita",
    "Nemocón",
    "Cogua",
    "Subachoque",
    "El Rosal",
    "Bojacá",
    "Zipacón",
    "Facatativá",
    "Albán",
    "La Vega",
    "Sasaima",
    "Villeta",
    "Quebradanegra",
    "Nimaima",
    "Nocaima",
    "Vergara",
    "Útica",
    "La Peña",
    "San Francisco",
    "Supatá",
    "Pacho",
    "Yacopí",
    "San Cayetano",
    "Villagómez",
    "Caparrapí",
    "Guaduas",
    "Puerto Salgar",
    "Chaguaní",
    "Bituima",
    "Vianí",
    "Guayabal de Síquima",
    "Pulí",
    "San Juan de Río Seco",
    "Anolaima",
    "Cachipay",
    "La Mesa",
    "Anapoima",
    "Apulo",
    "Tocaima",
    "Agua de Dios",
    "Ricaurte",
    "Nilo",
    "Jerusalén",
    "Tibacuy",
    "Venecia",
    "San Antonio del Tequendama",
    "Tena",
    "Silvania",
    "Granada",
    "Arbeláez",
    "Pandi",
    "San Bernardo",
    "Cabrera",
    "Venecia",
    "Pasca",
    "Fusagasugá",
    "Une",
    "Chipaque",
    "Cáqueza",
    "Fómeque",
    "Fosca",
    "Ubaque",
    "Choachí",
    "Gutiérrez",
    "Junín",
    "Gachalá",
    "Gachetá",
    "Gama",
    "Guasca",
    "Machetá",
    "Manta",
    "Tibirita",
    "Cucunubá",
    "Lenguazaque",
    "Guachetá",
    "Ráquira",
    "Samacá",
    "Sutatausa",
    "Tausa",
    "Carmen de Carupa",
    "Cucunubá",
    "Suesca",
    "Chocontá",
    "Villapinzón",
    "Ubaté",
    "Simijaca",
    "Susa",
    "Fúquene",
    "Guachetá",
    "Lenguazaque",
    "Cucunubá",
    "Sutatausa",
    "Tausa",
    "Carmen de Carupa"
  ],
  "Guainía": [
    "Inírida",
    "Barranco Minas",
    "Mapiripana",
    "San Felipe",
    "Puerto Colombia",
    "La Guadalupe",
    "Cacahual",
    "Pana Pana",
    "Morichal"
  ],
  "Guaviare": [
    "San José del Guaviare",
    "Calamar",
    "El Retorno",
    "Miraflores"
  ],
  "Huila": [
    "Neiva",
    "Pitalito",
    "Garzón",
    "La Plata",
    "Campoalegre",
    "Aipe",
    "Palermo",
    "Rivera",
    "Tello",
    "Baraya",
    "Villavieja",
    "Yaguará",
    "Hobo",
    "Iquira",
    "Teruel",
    "Algeciras",
    "Gigante",
    "Guadalupe",
    "Agrado",
    "Altamira",
    "Timaná",
    "Elías",
    "Saladoblanco",
    "Oporapa",
    "Tarqui",
    "Suaza",
    "Acevedo",
    "Palestina",
    "Íquira",
    "Nátaga",
    "Tesalia",
    "Paicol",
    "La Argentina",
    "Santa María",
    "Isnos",
    "San Agustín"
  ],
  "La Guajira": [
    "Riohacha",
    "Maicao",
    "Uribia",
    "Manaure",
    "Fonseca",
    "Barrancas",
    "Distracción",
    "Hatonuevo",
    "La Jagua del Pilar",
    "San Juan del Cesar",
    "Villanueva",
    "Urumita",
    "El Molino",
    "Albania",
    "Dibulla"
  ],
  "Magdalena": [
    "Santa Marta",
    "Ciénaga",
    "Fundación",
    "Aracataca",
    "El Banco",
    "Plato",
    "Zona Bananera",
    "Algarrobo",
    "Ariguaní",
    "Cerro San Antonio",
    "Chivolo",
    "Concordia",
    "El Piñón",
    "El Retén",
    "Guamal",
    "Nueva Granada",
    "Pedraza",
    "Pijiño del Carmen",
    "Pivijay",
    "Puebloviejo",
    "Remolino",
    "Sabanas de San Ángel",
    "Salamina",
    "San Sebastián de Buenavista",
    "San Zenón",
    "Santa Ana",
    "Santa Bárbara de Pinto",
    "Sitionuevo",
    "Tenerife",
    "Zapayán"
  ],
  "Meta": [
    "Villavicencio",
    "Acacías",
    "Granada",
    "San Martín",
    "Restrepo",
    "Cumaral",
    "El Dorado",
    "Guamal",
    "Castilla la Nueva",
    "San Carlos de Guaroa",
    "Puerto López",
    "Puerto Gaitán",
    "Cabuyaro",
    "Barranca de Upía",
    "Paratebueno",
    "Medina",
    "Uribe",
    "Lejanías",
    "El Calvario",
    "San Juanito",
    "Cubarral",
    "El Castillo",
    "Mesetas",
    "La Macarena",
    "Vistahermosa",
    "Puerto Concordia",
    "Puerto Lleras",
    "Puerto Rico",
    "Mapiripán",
    "Fuente de Oro"
  ],
  "Nariño": [
    "Pasto",
    "Tumaco",
    "Ipiales",
    "Túquerres",
    "Samaniego",
    "La Unión",
    "Sandona",
    "Consacá",
    "Ancuyá",
    "Linares",
    "Sandoná",
    "La Florida",
    "Nariño",
    "Chachagüí",
    "Buesaco",
    "Yacuanquer",
    "Tangua",
    "Funes",
    "Guachucal",
    "Cumbal",
    "Aldana",
    "Córdoba",
    "Potosí",
    "Gualmatán",
    "Contadero",
    "Cuaspud",
    "Pupiales",
    "Imués",
    "Carlosama",
    "Ospina",
    "Ricaurte",
    "Barbacoas",
    "Roberto Payán",
    "Magüí",
    "Mallama",
    "Providencia",
    "Leiva",
    "Policarpa",
    "Cumbitara",
    "Los Andes",
    "Sotomayor",
    "Taminango",
    "Colón",
    "San Bernardo",
    "Belén",
    "San Pablo",
    "Arboleda",
    "El Tambo",
    "La Cruz",
    "San Lorenzo",
    "La Tola",
    "Mosquera",
    "El Charco",
    "Francisco Pizarro",
    "Olaya Herrera",
    "Santa Bárbara",
    "Iscuandé",
    "El Rosario",
    "Tablón de Gómez",
    "Albán",
    "San Pedro de Cartago",
    "Puerres",
    "Sapuyes"
  ],
  "Norte de Santander": [
    "Cúcuta",
    "Ocaña",
    "Pamplona",
    "Villa del Rosario",
    "Los Patios",
    "Tibú",
    "El Zulia",
    "San Cayetano",
    "Puerto Santander",
    "Villa Caro",
    "Sardinata",
    "Convención",
    "El Tarra",
    "Teorama",
    "Hacarí",
    "La Playa",
    "Ábrego",
    "La Esperanza",
    "Cachirá",
    "Mutiscua",
    "Chitagá",
    "Silos",
    "Cucutilla",
    "Pamplonita",
    "Labateca",
    "Toledo",
    "Ragonvalia",
    "Herrán",
    "Durania",
    "Bochalema",
    "Chinácota",
    "Salazar",
    "Arboledas",
    "Gramalote",
    "Lourdes",
    "Santiago",
    "San Calixto"
  ],
  "Putumayo": [
    "Mocoa",
    "Puerto Asís",
    "Orito",
    "Valle del Guamuez",
    "Puerto Caicedo",
    "Puerto Guzmán",
    "Leguízamo",
    "Sibundoy",
    "San Francisco",
    "San Miguel",
    "Santiago",
    "Colón",
    "Villagarzón"
  ],
  "Quindío": [
    "Armenia",
    "Calarcá",
    "La Tebaida",
    "Montenegro",
    "Quimbaya",
    "Circasia",
    "Filandia",
    "Salento",
    "Pijao",
    "Córdoba",
    "Buenavista",
    "Génova"
  ],
  "Risaralda": [
    "Pereira",
    "Dosquebradas",
    "Santa Rosa de Cabal",
    "La Virginia",
    "Marsella",
    "Belén de Umbría",
    "Apía",
    "Santuario",
    "Balboa",
    "La Celia",
    "Guática",
    "Quinchía",
    "Mistrató",
    "Pueblo Rico"
  ],
  "San Andrés y Providencia": [
    "San Andrés",
    "Providencia",
    "Santa Catalina"
  ],
  "Santander": [
    "Bucaramanga",
    "Floridablanca",
    "Girón",
    "Piedecuesta",
    "Barrancabermeja",
    "San Gil",
    "Socorro",
    "Málaga",
    "Barbosa",
    "Vélez",
    "Charalá",
    "Simacota",
    "Zapatoca",
    "Villanueva",
    "Mogotes",
    "Onzaga",
    "Coromoro",
    "Encino",
    "Curití",
    "Barichara",
    "Cabrera",
    "Jordán",
    "Aratoca",
    "Los Santos",
    "Pinchote",
    "Palmar",
    "Palmas del Socorro",
    "Oiba",
    "Confines",
    "Aguada",
    "Albania",
    "Contratación",
    "El Guacamayo",
    "Galán",
    "Gambita",
    "Guadalupe",
    "Guapotá",
    "Hato",
    "La Belleza",
    "La Paz",
    "Landázuri",
    "Lebríja",
    "Los Andes",
    "Macaravita",
    "Matanza",
    "Ocamonte",
    "Puente Nacional",
    "Puerto Parra",
    "Puerto Wilches",
    "Rionegro",
    "Sabana de Torres",
    "San Andrés",
    "San Benito",
    "San José de Miranda",
    "San Miguel",
    "San Vicente de Chucurí",
    "Santa Bárbara",
    "Santa Helena del Opón",
    "Simacota",
    "Suaita",
    "Sucre",
    "Suratá",
    "Tona",
    "Valle de San José",
    "Vetas",
    "Yondó",
    "Chipatá",
    "Cimitarra",
    "El Carmen de Chucurí",
    "El Peñón",
    "Florián",
    "Guavatá",
    "Güepsa",
    "Jesús María",
    "Bolívar",
    "Capitanejo",
    "Carcasí",
    "Cepitá",
    "Cerrito",
    "Concepción",
    "Enciso",
    "Guaca",
    "Macaravita",
    "Molagavita",
    "San Joaquín",
    "San José de Miranda",
    "San Miguel",
    "Santa Bárbara",
    "Suratá"
  ],
  "Sucre": [
    "Sincelejo",
    "Corozal",
    "Sampués",
    "San Marcos",
    "Tolú",
    "Coveñas",
    "Ovejas",
    "Morroa",
    "Los Palmitos",
    "Galeras",
    "El Roble",
    "Chalán",
    "Coloso",
    "Palmito",
    "Buenavista",
    "Guaranda",
    "Majagual",
    "Sucre",
    "Santiago de Tolú",
    "Tolú Viejo",
    "San Pedro",
    "San Juan de Betulia",
    "San Benito Abad",
    "La Unión",
    "Caimito"
  ],
  "Tolima": [
    "Ibagué",
    "Espinal",
    "Melgar",
    "Girardot",
    "Honda",
    "Líbano",
    "Chaparral",
    "Purificación",
    "Mariquita",
    "Flandes",
    "Guamo",
    "Saldaña",
    "Armero",
    "Ambalema",
    "Venadillo",
    "Lérida",
    "Fresno",
    "Herveo",
    "Palocabildo",
    "Santa Isabel",
    "Falan",
    "Casabianca",
    "Villahermosa",
    "Anzoátegui",
    "Murillo",
    "Rovira",
    "Valle de San Juan",
    "Alpujarra",
    "Dolores",
    "Icononzo",
    "Cunday",
    "Villarrica",
    "Prado",
    "Suárez",
    "Ataco",
    "Planadas",
    "Rioblanco",
    "Roncesvalles",
    "Ortega",
    "Coyaima",
    "Natagaima",
    "San Antonio",
    "Carmen de Apicalá",
    "San Luis",
    "Coello",
    "Piedras"
  ],
  "Valle del Cauca": [
    "Cali",
    "Palmira",
    "Buenaventura",
    "Tuluá",
    "Cartago",
    "Buga",
    "Jamundí",
    "Yumbo",
    "Candelaria",
    "Florida",
    "Pradera",
    "Sevilla",
    "Caicedonia",
    "La Unión",
    "Roldanillo",
    "Zarzal",
    "Andalucía",
    "Ansermanuevo",
    "Argelia",
    "Bolívar",
    "Calima",
    "Dagua",
    "El Águila",
    "El Cairo",
    "El Cerrito",
    "El Dovio",
    "Ginebra",
    "Guacarí",
    "La Cumbre",
    "La Victoria",
    "Obando",
    "Restrepo",
    "Riofrío",
    "San Pedro",
    "Toro",
    "Trujillo",
    "Ulloa",
    "Versalles",
    "Vijes",
    "Yotoco",
    "Alcalá",
    "Bugalagrande"
  ],
  "Vaupés": [
    "Mitú",
    "Carurú",
    "Pacoa",
    "Taraira",
    "Papunaua",
    "Yavaraté"
  ],
  "Vichada": [
    "Puerto Carreño",
    "La Primavera",
    "Santa Rosalía",
    "Cumaribo"
  ]
};

// Función para obtener ciudades por departamento
export const getCitiesByDepartment = (department: string): string[] => {
  return COLOMBIAN_CITIES[department] || [];
};

// Función para obtener todas las ciudades
export const getAllCities = (): string[] => {
  return Object.values(COLOMBIAN_CITIES).flat();
};